import React from 'react';
import { IconProps } from './types';

export const OriginalsIcon: React.FC<IconProps> = (props) => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.2 2C3.98497 2 3 3.03036 3 4.30138V14.9526C3 15.7302 3.78231 16.236 4.44721 15.8882L7.65836 14.2086C8.50294 13.7669 9.49706 13.7669 10.3416 14.2086L13.5528 15.8882C14.2177 16.236 15 15.7302 15 14.9526V4.30138C15 3.03036 14.015 2 12.8 2H5.2ZM9.6539 5.31084C9.39145 4.76772 8.60855 4.76772 8.3461 5.31084L7.91729 6.19822C7.81167 6.4168 7.60123 6.56777 7.35808 6.59943L6.37092 6.72792C5.76672 6.80657 5.52479 7.54183 5.96678 7.95614L6.68892 8.63307C6.8668 8.79981 6.94718 9.04409 6.90253 9.28223L6.72123 10.249C6.61027 10.8407 7.24366 11.2952 7.77927 11.0081L8.65439 10.5391C8.86994 10.4236 9.13006 10.4236 9.34561 10.5391L10.2207 11.0081C10.7563 11.2952 11.3897 10.8407 11.2788 10.249L11.0975 9.28223C11.0528 9.04409 11.1332 8.79981 11.3111 8.63307L12.0332 7.95614C12.4752 7.54183 12.2333 6.80657 11.6291 6.72792L10.6419 6.59943C10.3988 6.56777 10.1883 6.4168 10.0827 6.19822L9.6539 5.31084Z"
    ></path>
  </svg>
);
